module.exports = __webpack_public_path__ + "img/boletincasa.5a35d9e7.jpg";